module.exports = {
      id: "0c11ea5ab50d714e5dcd4a7b61f80777area.svg-usage",
      viewBox: "0 0 482 436",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#0c11ea5ab50d714e5dcd4a7b61f80777area.svg",
      toString: function () {
        return this.url;
      }
    }